<template>
  <div class="shadow-off d-flex flex-column gap-3" data-testid="ru-wise-materiality">
    
    <MaterialityFiltersHeader
      :reportingType="localRuData.reporting_type || 'pl'"
      @update:reportingType="handleReportingTypeUpdate"
      :periods="localRuData.periods || []"
      @update:periods="handlePeriodsUpdate"
      :statementOptions="statementOptions"
      :minDate="minDate"
      :maxDate="maxDate"
      :showSelectedMonths="(localMultipleMaterialityToggle || (localRuData._id || []).length > 1) && (localRuData.periods || []).length > 0"
      @removeMonth="$emit('removeMonth', $event)"
      @periods-changed="$emit('periods-changed', $event)"
      :isViewMode="isViewMode"
      :isCommentaryView.sync="localViewCycleType"
      :cycletypeReadview.sync="localViewModuleType"
    >
      <template #additional-controls>
        <div class="d-flex align-center justify-center gap-3" data-testid="ru-wise-materiality__toggle" v-if="!isViewMode">
          <span :class="`${localMultipleMaterialityToggle ? 'grey--text text--lighten-1' : ''} font-weight-medium`">
            Single Materiality
          </span>
          <v-switch
            data-testid="ru-wise-materiality__toggle-switch"
            inset
            dense
            class="mt-0 custom-primary-switch"
            v-model="localMultipleMaterialityToggle"
            label=""
          
            hide-details
            id="materiality-switch"
          ></v-switch>
          <span :class="`${!localMultipleMaterialityToggle ? 'grey--text text--lighten-1' : ''} font-weight-medium`">
            Multiple Materiality
          </span>
        </div>
      </template>
    </MaterialityFiltersHeader>
    
    <div v-if="!isViewMode" data-testid="ru-wise-materiality__edit-mode">
    <!-- Single Materiality View -->
    <div class="rutablesinglemateriality d-flex " v-if="!localMultipleMaterialityToggle" data-testid="ru-wise-materiality__single-view">
      <v-row no-gutters class="gap-2 pb-2">
        <v-col>
          <!-- Local Materiality Section -->
          <v-card class="rucard d-flex flex-column gap-6" data-testid="ru-wise-materiality__local-card">
            <div class="" data-testid="ru-wise-materiality__local-header">
              <h4 class="font-weight-semibold" data-testid="ru-wise-materiality__local-title">
                {{ $nova.labelsName('materiality_page', 'commentary_local_key_label', 'Local') }} Materiality Amount & Percentage
              </h4>
              <v-spacer />
              <v-tooltip bottom content-class="tooltip-bottom" v-if="(!localRuLevelEdit.local && !isViewMode)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="primary" @click="updateRuLevelEdit('local', true)" id="edit-local-materiality" data-testid="ru-wise-materiality__edit-local-btn">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit local values</span>
              </v-tooltip>
            </div>
            <div class="" data-testid="ru-wise-materiality__local-content">
              <v-row class="mt-1" no-gutters>
                <v-col cols="6" >
                  <h5 class="font-weight-medium" data-testid="ru-wise-materiality__local-proforma-label">vs {{ proformaLabel }}</h5>
                </v-col>
                <v-col cols="6" >
                  <h5 class="font-weight-medium" data-testid="ru-wise-materiality__local-forecast-label">vs {{ forecastLabel }}</h5>
                </v-col>
              </v-row>
              <v-row>
                <!-- Proforma Column -->
                <v-col cols="6" class="d-flex flex-column gap-2">
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div class="d-flex flex-column gap-2" v-if="localRuLevelEdit.local">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_proforma"
                          @input="updateRuDataField('control_thresholds_amount_proforma', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_proforma"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_c_a_pro"
                          data-testid="ru-wise-materiality__local-ctrl-amt-proforma-input">
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template>
                        </lb-number>
                        
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_proforma"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_c_a_pro"
                          disabled
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-ctrl-amt-proforma-input"
                        >
                         <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template>
                        </lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_proforma"
                          @input="updateRuDataField('control_thresholds_percent_proforma', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          backgroundColor="#FFF"
                          min="0"
                          :value="localRuData.control_thresholds_percent_proforma || 999999"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_proforma"
                          :disabled="true"
                          outlined
                          dense
                          hidedetails
                          id="l_c_p_pro"
                          data-testid="ru-wise-materiality__local-ctrl-pct-proforma-input"
                        >
                       <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>

                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_proforma"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_proforma || 999999"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_c_p_pro"
                          disabled
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-ctrl-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_proforma"
                          @input="updateRuDataField('management_thresholds_amount_proforma', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_proforma"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_m_a_pro"
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-mgmt-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_proforma"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_proforma"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_m_a_pro"
                          disabled
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-mgmt-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_proforma"
                          @input="updateRuDataField('management_thresholds_percent_proforma', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_m_p_pro"
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-mgmt-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_proforma"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_proforma"
                          outlined
                          dense
                          hidedetails
                          id="l_m_p_pro"
                          disabled
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-mgmt-pct-proforma-input"
                        >
                          <template #append>
                            <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                          </template>
                        </lb-number>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Forecast Column -->
                <v-col cols="6" class="d-flex flex-column gap-2">
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_forecast"
                          @input="updateRuDataField('control_thresholds_amount_forecast', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_forecast"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          data-testid="ru-wise-materiality__local-ctrl-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_forecast"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_forecast"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          disabled
                          data-testid="ru-wise-materiality__local-ctrl-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_forecast"
                          @input="updateRuDataField('control_thresholds_percent_forecast', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_c_a_fore"
                          data-testid="ru-wise-materiality__local-ctrl-pct-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_forecast"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_c_a_fore"
                          disabled
                          data-testid="ru-wise-materiality__local-ctrl-pct-forecast-input"
                        >
                          <template #append>
                            <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                          </template>
                        </lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_forecast"
                          @input="updateRuDataField('management_thresholds_amount_forecast', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_c_m_fore"
                          data-testid="ru-wise-materiality__local-mgmt-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_forecast"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_c_m_fore"
                          disabled
                          data-testid="ru-wise-materiality__local-mgmt-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.local" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_forecast"
                          @input="updateRuDataField('management_thresholds_percent_forecast', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_m_a_fore"
                          data-testid="ru-wise-materiality__local-mgmt-pct-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__local-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_forecast"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="l_m_a_fore"
                          disabled
                          data-testid="ru-wise-materiality__local-mgmt-pct-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>





        
        <v-col>
           <!-- Regional Materiality Section -->
          <v-card class="rucard d-flex flex-column gap-6" flat data-testid="ru-wise-materiality__regional-card">
            <div class="" data-testid="ru-wise-materiality__regional-header">
              <h4 class="font-weight-semibold" data-testid="ru-wise-materiality__regional-title">
                {{ $nova.labelsName('materiality_page', 'commentary_regional_key_label', 'Regional') }} Materiality Amount & Percentage
              </h4>
              <v-spacer />
              <v-tooltip bottom content-class="tooltip-bottom" v-if="(!localRuLevelEdit.regional && !isViewMode)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="primary" @click="updateRuLevelEdit('regional', true)" id="edit-regional-materiality" data-testid="ru-wise-materiality__edit-regional-btn">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit regional values</span>
              </v-tooltip>
            </div>
            <div class="" data-testid="ru-wise-materiality__regional-content">
              <v-row class="mt-1" no-gutters>
                <v-col cols="6">
                  <h5 class="font-weight-medium" data-testid="ru-wise-materiality__regional-proforma-label">vs {{ proformaLabel }}</h5>
                </v-col>
                <v-col cols="6">
                  <h5 class="font-weight-medium" data-testid="ru-wise-materiality__regional-forecast-label">vs {{ forecastLabel }}</h5>
                </v-col>
              </v-row>
              <v-row>
                <!-- Regional Proforma Column -->
                <v-col cols="6" class="d-flex flex-column gap-2">
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_regional_proforma"
                          @input="updateRuDataField('control_thresholds_amount_regional_proforma', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_c_a_pro"
                          data-testid="ru-wise-materiality__regional-ctrl-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_regional_proforma"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_c_a_pro"
                          disabled
                          data-testid="ru-wise-materiality__regional-ctrl-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_regional_proforma"
                          @input="updateRuDataField('control_thresholds_percent_regional_proforma', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_regional_proforma || 999999"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          :disabled="true"
                          outlined
                          dense
                          id="r_c_p_pro"
                          data-testid="ru-wise-materiality__regional-ctrl-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_regional_proforma"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_regional_proforma || 999999"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_c_p_pro"
                          disabled
                          data-testid="ru-wise-materiality__regional-ctrl-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_regional_proforma"
                          @input="updateRuDataField('management_thresholds_amount_regional_proforma', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_m_a_pro"
                          data-testid="ru-wise-materiality__regional-mgmt-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_regional_proforma"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_m_a_pro"
                          disabled
                          data-testid="ru-wise-materiality__regional-mgmt-amt-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_regional_proforma"
                          @input="updateRuDataField('management_thresholds_percent_regional_proforma', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_m_p_pro"
                          data-testid="ru-wise-materiality__regional-mgmt-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_regional_proforma"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_regional_proforma || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_regional_proforma"
                          hidedetails
                          backgroundColor="#FFF"
                          outlined
                          dense
                          id="r_m_p_pro"
                          disabled
                          data-testid="ru-wise-materiality__regional-mgmt-pct-proforma-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Regional Forecast Column -->
                <v-col cols="6" class="d-flex flex-column gap-2">
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_regional_forecast"
                          @input="updateRuDataField('control_thresholds_amount_regional_forecast', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_c_a_fore"
                          data-testid="ru-wise-materiality__regional-ctrl-amt-forecast-input"
                        ><template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_amount_regional_forecast"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.control_thresholds_amount_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_amount_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_c_a_fore"
                          disabled
                          data-testid="ru-wise-materiality__regional-ctrl-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_regional_forecast"
                          @input="updateRuDataField('control_thresholds_percent_regional_forecast', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_c_r_fore"
                          data-testid="ru-wise-materiality__regional-ctrl-pct-forecast-input"
                        ><template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.control_thresholds_percent_regional_forecast"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.control_thresholds_percent_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.control_thresholds_percent_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_c_r_fore"
                          disabled
                          data-testid="ru-wise-materiality__regional-ctrl-pct-forecast-input"
                        ><template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_regional_forecast"
                          @input="updateRuDataField('management_thresholds_amount_regional_forecast', $event)"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_m_a_fore"
                          data-testid="ru-wise-materiality__regional-mgmt-amt-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_amount_regional_forecast"
                          appendiconinner="mdi-cash"
                          min="0"
                          :value="localRuData.management_thresholds_amount_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_amount_regional_forecast"
                          outlined
                          dense
                          hidedetails
                          backgroundColor="#FFF"
                          id="r_m_a_fore"
                          disabled
                          data-testid="ru-wise-materiality__regional-mgmt-amt-forecast-input"
                        >
                          <template #append>
                            <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                          </template>
                        </lb-number>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  class="">
                    <v-col cols="12">
                      <div v-if="localRuLevelEdit.regional" class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_regional_forecast"
                          @input="updateRuDataField('management_thresholds_percent_regional_forecast', $event)"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_regional_forecast"
                          outlined
                          hidedetails
                          backgroundColor="#FFF"
                          dense
                          id="r_m_p_fore"
                          data-testid="ru-wise-materiality__regional-mgmt-pct-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                      <div v-else class="d-flex flex-column gap-2">
                        <span class="rutablelabel" data-testid="ru-wise-materiality__regional-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                        <lb-number
                          v-model="localRuData.management_thresholds_percent_regional_forecast"
                          appendiconinner="mdi-percent-box-outline"
                          min="0"
                          :value="localRuData.management_thresholds_percent_regional_forecast || '0'"
                          placeholder="Enter"
                          :error="ruError.management_thresholds_percent_regional_forecast"
                          outlined
                          hidedetails
                          backgroundColor="#FFF"
                          dense
                          id="r_m_p_fore"
                          disabled
                          data-testid="ru-wise-materiality__regional-mgmt-pct-forecast-input"
                        >
                        <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
      

     
      
    </div>


    <!-- Multiple Materiality View -->
    <div v-else class="multiplemateriality" data-testid="ru-wise-materiality__multiple-view">
      <lb-datatablenew
        data-testid="ru-wise-materiality__multiple-table"
        :headers="ruHeaders"
        :items="formattedRUDataArray"
        :perpage="itemsPerPage"
        :hidePagination="false"
        :enableslot="[
          'period',
          'datatypes',
          'edit_buttons',
          'control_thresholds_amount',
          'control_thresholds_percent',
          'management_thresholds_amount',
          'management_thresholds_percent',
          'control_thresholds_amount_regional',
          'control_thresholds_percent_regional',
          'management_thresholds_amount_regional',
          'management_thresholds_percent_regional'
        ]"
        :loading="loading"
        class="v-table-color-materiality"
      >
        <template v-slot:period="{ item }">
          <div class="ellipsis-on" data-testid="ru-wise-materiality__period-name">{{ formatPeriod(item.periodKey) }}</div>
        </template>
        <template v-slot:datatypes="">
          <div class="d-flex flex-column gap-5" data-testid="ru-wise-materiality__datatypes-cell">
          <div class="ellipsis-on" data-testid="ru-wise-materiality__datatype-proforma">vs {{ proformaLabel }}</div>
          <div class="ellipsis-on" data-testid="ru-wise-materiality__datatype-forecast">vs {{ forecastLabel }}</div>
          </div>
        </template>
        <template v-slot:edit_buttons="{ item }">
          <v-col v-if="ruLevelEdit.enable" data-testid="ru-wise-materiality__edit-buttons-cell">
            <v-row data-testid="ru-wise-materiality__proforma-edit-row">
              <v-tooltip bottom content-class="tooltip-bottom" v-if="editableRUs.proforma.indexOf(item.periodKey) === -1" data-testid="ru-wise-materiality__edit-proforma-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="$emit('editRu', { id: item.periodKey, type: 'proforma' })" :data-testid="`ru-wise-materiality__edit-proforma-${item.periodKey}`">
                    <img src="/img/icons/PenEditIcon.svg" alt="Edit-Proforma" data-testid="ru-wise-materiality__edit-proforma-icon" />
                  </v-btn>
                </template>
                <span>Edit {{ proformaLabel }} RU</span>
              </v-tooltip>
              <v-tooltip bottom content-class="tooltip-bottom" v-else data-testid="ru-wise-materiality__cancel-proforma-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="$emit('cancelEditRu', { id: item.periodKey, type: 'proforma' })" :data-testid="`ru-wise-materiality__cancel-proforma-${item.periodKey}`">
                    <v-icon data-testid="ru-wise-materiality__cancel-proforma-icon">mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Cancel</span>
              </v-tooltip>
            </v-row>
            <v-row data-testid="ru-wise-materiality__forecast-edit-row">
              <v-tooltip bottom content-class="tooltip-bottom" v-if="editableRUs.forecast.indexOf(item.periodKey) === -1" data-testid="ru-wise-materiality__edit-forecast-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="$emit('editRu', { id: item.periodKey, type: 'forecast' })" :data-testid="`ru-wise-materiality__edit-forecast-${item.periodKey}`">
                    <img src="/img/icons/PenEditIcon.svg" alt="Edit-Forecast" data-testid="ru-wise-materiality__edit-forecast-icon" />
                  </v-btn>
                </template>
                <span>Edit {{ forecastLabel }} RU</span>
              </v-tooltip>
              <v-tooltip bottom content-class="tooltip-bottom" v-else data-testid="ru-wise-materiality__cancel-forecast-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="$emit('cancelEditRu', { id: item.periodKey, type: 'forecast' })" :data-testid="`ru-wise-materiality__cancel-forecast-${item.periodKey}`">
                    <v-icon data-testid="ru-wise-materiality__cancel-forecast-icon">mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Cancel</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </template>
        <template v-slot:control_thresholds_amount="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__control-amount-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__control-amount-proforma-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_amount_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_amount_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_amount_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__control-amount-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__control-amount-forecast-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_amount_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_amount_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_amount_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:control_thresholds_percent="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__control-percent-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__control-percent-proforma-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_percent_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_percent_proforma || 999999"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_percent_proforma"
              :disabled="true"
              class="cell-input"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__control-percent-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__control-percent-forecast-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_percent_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_percent_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_percent_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:management_thresholds_amount="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__management-amount-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__management-amount-proforma-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_amount_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_amount_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_amount_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__management-amount-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__management-amount-forecast-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_amount_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_amount_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_amount_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:management_thresholds_percent="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__management-percent-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__management-percent-proforma-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_percent_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_percent_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_percent_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__management-percent-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__management-percent-forecast-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_percent_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_percent_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_percent_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:control_thresholds_amount_regional="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__regional-control-amount-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-control-amount-proforma-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_amount_regional_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_amount_regional_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_amount_regional_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__regional-control-amount-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-control-amount-forecast-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_amount_regional_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_amount_regional_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_amount_regional_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:control_thresholds_percent_regional="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__regional-control-percent-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-control-percent-proforma-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_percent_regional_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_percent_regional_proforma || 999999"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_percent_regional_proforma"
              :disabled="true"
              class="cell-input"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__regional-control-percent-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-control-percent-forecast-input"
              v-model="formattedRUData[item.periodKey].control_thresholds_percent_regional_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].control_thresholds_percent_regional_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].control_thresholds_percent_regional_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:management_thresholds_amount_regional="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__regional-management-amount-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-management-amount-proforma-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_amount_regional_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_amount_regional_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_amount_regional_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__regional-management-amount-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-management-amount-forecast-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_amount_regional_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_amount_regional_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_amount_regional_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
        <template v-slot:management_thresholds_percent_regional="{ item }">
          <div class="py-1" data-testid="ru-wise-materiality__regional-management-percent-proforma-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-management-percent-proforma-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_percent_regional_proforma"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_percent_regional_proforma || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_percent_regional_proforma"
              class="cell-input"
              :disabled="editableRUs.proforma.indexOf(item.periodKey) === -1"
            />
          </div>
          <div class="py-1" data-testid="ru-wise-materiality__regional-management-percent-forecast-container">
            <lb-number
              data-testid="ru-wise-materiality__regional-management-percent-forecast-input"
              v-model="formattedRUData[item.periodKey].management_thresholds_percent_regional_forecast"
              min="0"
              hidedetails
              :value="formattedRUData[item.periodKey].management_thresholds_percent_regional_forecast || '0'"
              label=""
              :error="formattedRUErrorData[item.periodKey].management_thresholds_percent_regional_forecast"
              class="cell-input"
              :disabled="editableRUs.forecast.indexOf(item.periodKey) === -1"
            />
          </div>
        </template>
      </lb-datatablenew>
    </div>

    </div>
    <!--View  Materiality view-->
    <div v-else data-testid="ru-wise-materiality__view-mode">
      <!-- Single Materiality View -->
      <div class="rutablesinglemateriality d-flex" data-testid="ru-wise-materiality__view-single">
        <v-row no-gutters class="gap-2">
          <v-col>
            <!-- Local Materiality Section -->
            <v-card class="rucard d-flex flex-column gap-6" flat data-testid="ru-wise-materiality__view-local-card">
              <div class="" data-testid="ru-wise-materiality__view-local-header">
                <h4 class="font-weight-semibold" data-testid="ru-wise-materiality__view-local-title">
                  {{ $nova.labelsName('materiality_page', 'commentary_local_key_label', 'Local') }} Materiality Amount & Percentage
                </h4>
                <v-spacer />
              </div>
              <div class="" data-testid="ru-wise-materiality__view-local-content">
                <v-row class="mt-1" no-gutters>
                  <v-col cols="6">
                    <h5 class="font-weight-medium" data-testid="ru-wise-materiality__view-local-proforma-label">vs {{ proformaLabel }}</h5>
                  </v-col>
                  <v-col cols="6">
                    <h5 class="font-weight-medium" data-testid="ru-wise-materiality__view-local-forecast-label">vs {{ forecastLabel }}</h5>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- Proforma Column -->
                  <v-col cols="6" class="d-flex flex-column gap-2">
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_amount_proforma"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_amount_proforma || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-ctrl-amt-proforma-input"
                          >
                            <template #append>
                              <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                            </template>
                          </lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_percent_proforma"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_percent_proforma || 999999"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-ctrl-pct-proforma-input"
                          >
                            <template #append>
                              <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                            </template>
                          </lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_amount_proforma"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_amount_proforma || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-mgmt-amt-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_percent_proforma"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_percent_proforma || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-mgmt-pct-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- Forecast Column -->
                  <v-col cols="6" class="d-flex flex-column gap-2">
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_amount_forecast"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_amount_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-ctrl-amt-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_percent_forecast"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_percent_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-ctrl-pct-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_amount_forecast"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_amount_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-mgmt-amt-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-local-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_percent_forecast"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_percent_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            disabled
                            backgroundColor="#FFF"
                            data-testid="ru-wise-materiality__view-local-mgmt-pct-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>

          <v-col>
            <!-- Regional Materiality Section -->
            <v-card class="rucard d-flex flex-column gap-6" flat data-testid="ru-wise-materiality__view-regional-card">
              <div class="" data-testid="ru-wise-materiality__view-regional-header">
                <h4 class="font-weight-semibold" data-testid="ru-wise-materiality__view-regional-title">
                  {{ $nova.labelsName('materiality_page', 'commentary_regional_key_label', 'Regional') }} Materiality Amount & Percentage
                </h4>
                <v-spacer />
              </div>
              <div class="" data-testid="ru-wise-materiality__view-regional-content">
                <v-row class="mt-1" no-gutters>
                  <v-col cols="6">
                    <h5 class="font-weight-medium" data-testid="ru-wise-materiality__view-regional-proforma-label">vs {{ proformaLabel }}</h5>
                  </v-col>
                  <v-col cols="6">
                    <h5 class="font-weight-medium" data-testid="ru-wise-materiality__view-regional-forecast-label">vs {{ forecastLabel }}</h5>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- Regional Proforma Column -->
                  <v-col cols="6" class="d-flex flex-column gap-2">
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-ctrl-amt-proforma-label">Control Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_amount_regional_proforma"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_amount_regional_proforma || '0'"
                            placeholder="Enter"
                            hidedetails
                            backgroundColor="#FFF"
                            outlined
                            dense
                            disabled
                            data-testid="ru-wise-materiality__view-regional-ctrl-amt-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-ctrl-pct-proforma-label">Control Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_percent_regional_proforma"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_percent_regional_proforma || 999999"
                            placeholder="Enter"
                            hidedetails
                            backgroundColor="#FFF"
                            outlined
                            dense
                            disabled
                            data-testid="ru-wise-materiality__view-regional-ctrl-pct-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-mgmt-amt-proforma-label">Management Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_amount_regional_proforma"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_amount_regional_proforma || '0'"
                            placeholder="Enter"
                            hidedetails
                            backgroundColor="#FFF"
                            outlined
                            dense
                            disabled
                            data-testid="ru-wise-materiality__view-regional-mgmt-amt-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-mgmt-pct-proforma-label">Management Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_percent_regional_proforma"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_percent_regional_proforma || '0'"
                            placeholder="Enter"
                            hidedetails
                            backgroundColor="#FFF"
                            outlined
                            dense
                            disabled
                            data-testid="ru-wise-materiality__view-regional-mgmt-pct-proforma-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- Regional Forecast Column -->
                  <v-col cols="6" class="d-flex flex-column gap-2">
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-ctrl-amt-forecast-label">Control Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_amount_regional_forecast"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_amount_regional_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            backgroundColor="#FFF"
                            disabled
                            data-testid="ru-wise-materiality__view-regional-ctrl-amt-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-ctrl-pct-forecast-label">Control Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.control_thresholds_percent_regional_forecast"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.control_thresholds_percent_regional_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            backgroundColor="#FFF"
                            disabled
                            data-testid="ru-wise-materiality__view-regional-ctrl-pct-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-mgmt-amt-forecast-label">Management Thresholds Amount</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_amount_regional_forecast"
                            appendiconinner="mdi-cash"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_amount_regional_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            dense
                            hidedetails
                            backgroundColor="#FFF"
                            disabled
                            data-testid="ru-wise-materiality__view-regional-mgmt-amt-forecast-input"
                          >
                        <template #append>
                          <img src="/img/icons/cashIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="">
                      <v-col cols="12">
                        <div class="d-flex flex-column gap-2">
                          <span class="rutablelabel" data-testid="ru-wise-materiality__view-regional-mgmt-pct-forecast-label">Management Thresholds Percentage</span>
                          <lb-number
                            v-model="viewMaterialityData.management_thresholds_percent_regional_forecast"
                            appendiconinner="mdi-percent-box-outline"
                            min="0"
                            :value="viewMaterialityData.management_thresholds_percent_regional_forecast || '0'"
                            placeholder="Enter"
                            outlined
                            hidedetails
                            backgroundColor="#FFF"
                            dense
                            disabled
                            data-testid="ru-wise-materiality__view-regional-mgmt-pct-forecast-input"
                          >
                          <template #append>
                          <img src="/img/icons/percentIcon.svg" alt="icon" class="input-icon" />
                        </template></lb-number>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>


  </div>
</template>

<script>
import MaterialityFiltersHeader from './MaterialityFiltersHeader.vue';

export default {
  name: 'RUWiseMateriality',
  components: {
    MaterialityFiltersHeader,
  },
  props: {
    ruData: {
      type: Object,
      default: () => ({}),
    },
    ruError: {
      type: Object,
      default: () => ({}),
    },
    ruLevelEdit: {
      type: Object,
      default: () => ({ local: false, regional: false, enable: false }),
    },
    isViewMode: {
      type: Boolean,
      default: false,
    },
    isWPPClient: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
    multipleMaterialityToggle: {
      type: Boolean,
      default: false,
    },
    formattedRUData: {
      type: Object,
      default: () => ({}),
    },
    formattedRUErrorData: {
      type: Object,
      default: () => ({}),
    },
    infoMessage: {
      type: String,
      default: '',
    },
    editableRUs: {
      type: Object,
      default: () => ({ proforma: [], forecast: [] }),
    },
    viewRULevelMaterialityData: {
      type: Array,
      default: () => [],
    },
    // View mode filter state props (to preserve user selections)
    viewCycleType: {
      type: String,
      default: 'actual'
    },
    viewModuleType: {
      type: String,
      default: 'pl'
    },
  },
  data() {
    return {
      selectedStatementType: 'pl',
      statementOptions: [{labelName: 'Profit & Loss',name: 'pl'}, {labelName: 'Balance Sheet', name: 'bs'}],
      ruCurrentPage: 1,
      itemsPerPage: 8,
      loading: false,
    };
  },
  computed: {
    /**
     * Headers configuration for lb-datatablenew component
     */
    ruHeaders() {
      return [
        { text: this.$nova.labelsName('materiality_page', 'month_label', 'Period'), value: 'period', sortable: false },
        { text: '', value: 'datatypes', sortable: false },
        { text: 'Action', value: 'edit_buttons', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_local_control_amount_shortform_label', 'LC Amt'), value: 'control_thresholds_amount', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_local_control_percentage_shortform_label', 'LC %'), value: 'control_thresholds_percent', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_local_management_amount_shortform_label', 'LM Amt'), value: 'management_thresholds_amount', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_local_management_precentage_shortform_label', 'LM %'), value: 'management_thresholds_percent', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_regional_control_amount_shortform_label', 'RC Amt'), value: 'control_thresholds_amount_regional', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_regional_control_percentage_shortform_label', 'RC %'), value: 'control_thresholds_percent_regional', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_regional_management_amount_shortform_label', 'RM Amt'), value: 'management_thresholds_amount_regional', sortable: false },
        { text: this.$nova.labelsName('materiality_page', 'commentary_regional_management_percentage_shortform_label', 'RM %'), value: 'management_thresholds_percent_regional', sortable: false },
      ];
    },
    /**
     * Convert formattedRUData object to array format for lb-datatablenew
     */
    formattedRUDataArray() {
      if (!this.formattedRUData || Object.keys(this.formattedRUData).length === 0) {
        return [];
      }
      return Object.keys(this.formattedRUData).map(periodKey => ({
        periodKey,
        ...this.formattedRUData[periodKey]
      }));
    },
    localRuData: {
      get() { 
        const data = { ...this.ruData };
        // Apply default 999999 for percentage fields when value is 0 or falsy
        if (!data.control_thresholds_percent_proforma) {
          data.control_thresholds_percent_proforma = 999999;
        }
        if (!data.control_thresholds_percent_regional_proforma) {
          data.control_thresholds_percent_regional_proforma = 999999;
        }
        return data;
      },
      set(val) {
        this.$emit('update:ruData', val);
      },
    },
    localRuLevelEdit: {
      get() {
        return this.ruLevelEdit;
      },
      set(val) {
        this.$emit('update:ruLevelEdit', val);
      },
    },
    localMultipleMaterialityToggle: {
      get() {
        return this.multipleMaterialityToggle;
      },
      set(val) {
        this.$emit('update:multipleMaterialityToggle', val);
      },
    },
    localFormattedRUData: {
      get() {
        return this.formattedRUData;
      },
      set(val) {
        this.$emit('update:formattedRUData', val);
      },
    },
    /**
     * Local view cycle type with two-way binding to parent
     */
    localViewCycleType: {
      get() {
        return this.viewCycleType;
      },
      set(val) {
        this.$emit('update:viewCycleType', val);
      },
    },
    /**
     * Local view module type with two-way binding to parent
     */
    localViewModuleType: {
      get() {
        return this.viewModuleType;
      },
      set(val) {
        this.$emit('update:viewModuleType', val);
      },
    },
    /**
     * Safe accessor for view mode data with default 0 values
     */
    viewMaterialityData() {
      if (this.viewRULevelMaterialityData && this.viewRULevelMaterialityData.length > 0) {
        return this.viewRULevelMaterialityData[0];
      }
      // Return default object with 0 values when data is empty
      return {
        control_thresholds_amount_proforma: 0,
        control_thresholds_percent_proforma: 999999,
        management_thresholds_amount_proforma: 0,
        management_thresholds_percent_proforma: 0,
        control_thresholds_amount_forecast: 0,
        control_thresholds_percent_forecast: 0,
        management_thresholds_amount_forecast: 0,
        management_thresholds_percent_forecast: 0,
        control_thresholds_amount_regional_proforma: 0,
        control_thresholds_percent_regional_proforma: 999999,
        management_thresholds_amount_regional_proforma: 0,
        management_thresholds_percent_regional_proforma: 0,
        control_thresholds_amount_regional_forecast: 0,
        control_thresholds_percent_regional_forecast: 0,
        management_thresholds_amount_regional_forecast: 0,
        management_thresholds_percent_regional_forecast: 0,
      };
    },
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.localRuData.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.localRuData.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    forecastLabel() {
      return this.localRuData.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  },
  methods: {
    /**
     * Format period from YYYY-MM to MM-YYYY format for display
     * @param {string} period - Period in YYYY-MM format
     * @returns {string} Period in MM-YYYY format
     */
    formatPeriod(period) {
      if (!period) return '';
      const [year, month] = period.split('-');
      return `${month}-${year}`;
    },
    updateRuLevelEdit(key, value) {
      const newVal = { ...this.ruLevelEdit, [key]: value };
      this.$emit('update:ruLevelEdit', newVal);
    },
    /**
     * Handle reporting type update from MaterialityFiltersHeader
     * Properly updates the ruData object and emits to parent
     * @param {string} value - New reporting type value ('pl' or 'bs')
     */
    handleReportingTypeUpdate(value) {
      const updatedRuData = { ...this.ruData, reporting_type: value };
      this.$emit('update:ruData', updatedRuData);
    },
    /**
     * Handle periods update from MaterialityFiltersHeader
     * Properly updates the ruData object and emits to parent
     * @param {Array} value - New periods array
     */
    handlePeriodsUpdate(value) {
      const updatedRuData = { ...this.ruData, periods: value };
      this.$emit('update:ruData', updatedRuData);
    },
    /**
     * Update a specific field in ruData and emit the updated object to parent
     * This is needed because v-model on computed property nested fields doesn't trigger the setter
     * @param {string} fieldName - The field name to update
     * @param {any} value - The new value for the field
     */
    updateRuDataField(fieldName, value) {
      const updatedRuData = { ...this.ruData, [fieldName]: value };
      this.$emit('update:ruData', updatedRuData);
    },
  },
    watch:{
    'localRuData.periods'(newVal, oldVal){
      if (this.isViewMode) {
      if (newVal && newVal.length > 0 && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        console.log(newVal,"newVal");
        
        this.$emit('periods-changed', newVal);
      }
    }
  }
}
};
</script>

<style scoped>
.rutablelabel {
  color: #828285;
  margin-bottom: 5px;
}
.selectmonth {
  color: #828285;
}
.ellipsis-on {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rucard{
  background-color: var(--grey-50);
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08) !important;

}
.v-table-color-materiality  tr td {
  padding: 0px 4px !important;
}

/* Custom red switch styles */
.custom-primary-switch >>> .v-input--switch__track {
  background-color: var( --color-primary-base) !important;
  opacity: 1 !important;
}

.custom-primary-switch.v-input--is-dirty >>> .v-input--switch__track {
  background-color: var( --color-primary-base) !important;
}

.custom-primary-switch >>> .v-input--switch__thumb {
  background-color: #ffffff !important;
}
</style>
